var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBowtie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Bow Tie"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.632 2.5H20.6368C17.8554 2.5 15.1911 3.56471 13.1817 5.46373H10.8181C8.81254 3.56857 6.15 2.5 3.36301 2.5H2.36777V6.9456V11.3912V15.8368H3.36301C3.5986 15.8368 3.83342 15.8285 4.0669 15.8135L2 18.2109L7.95043 22.178L11.0521 12.8731H12.9477L16.0494 22.178L22 18.2109L19.9329 15.8135C20.1666 15.8285 20.4012 15.8368 20.637 15.8368H21.632V11.3912V6.9456V2.5ZM3.84963 3.99422C6.07186 4.1069 8.15091 4.99178 9.7771 6.51899V8.42747H5.3315V9.90934H9.7771V11.8176C8.15091 13.3448 6.07186 14.2297 3.84963 14.3426V3.99422ZM7.15817 19.8687L4.2174 17.9083L6.36977 15.4121C7.28012 15.1491 8.17348 14.7652 9.03501 14.238L7.15817 19.8687ZM12.7408 11.3912H11.259V6.9456H12.7408V11.3912ZM19.7824 17.9083L16.8416 19.8687L14.9648 14.238C15.7715 14.7318 16.6579 15.1314 17.63 15.4121L19.7824 17.9083ZM20.1502 14.3426C17.928 14.2299 15.8489 13.345 14.2227 11.8178V9.90934H18.6683V8.42747H14.2227V6.51899C15.8489 4.99178 17.928 4.1069 20.1502 3.99422V14.3426Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBowtie);
export default __webpack_public_path__ + "static/media/icon-bowtie.9b34945a65a81ddd92c320770add0a16.svg";
export { ForwardRef as ReactComponent };